import { ONARK_TRAINING_PATH } from '@onark/shared/welcomeAboardFunnelClass';

/**
 * The free OnArk training, as a guest class on this same Next app, so a
 * relative path always works.
 *
 * The path itself lives in @onark/shared beside the course ids, because the api
 * needs it too (the Welcome Aboard status page's demo CTA) and a second copy is
 * exactly how one surface gets left pointing at a retired class. Imported from
 * the SUBPATH, never the barrel — the barrel pulls bullmq into the client
 * bundle.
 */
export { ONARK_TRAINING_PATH };

export function resolveOnarkTrainingHref(): string {
  return ONARK_TRAINING_PATH;
}
